import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import DocumentoImpuestosRetencionForm from './DocumentoImpuestosRetencionForm';
import DocumentoImpuestosRetencionList from './DocumentoImpuestosRetencionList';

class DocumentoImpuestosRetencionesManager extends Component {

  state = {}

  handleOnAdd = (data) => {
    const { ImpuestosDR = [] } = this.props.data;
    const { RetencionesDR = [] } = ImpuestosDR;
    const { RetencionDR = [] } = RetencionesDR;

    const newData = RetencionDR.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
        RetencionesDR: {
          RetencionDR: data
        }
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { ImpuestosDR = [] } = this.props.data;
    const { RetencionesDR = [] } = ImpuestosDR;
    const { RetencionDR = [] } = RetencionesDR;

    return (
      <fieldset>
        <legend>Retenciones</legend>

        <DocumentoImpuestosRetencionForm
          data={ data }
          onAdd={ this.handleOnAdd }
        />

        <DocumentoImpuestosRetencionList
          data={ RetencionDR }
          onEdit={ this.handleOnEdit }
          onChange={ this.handleOnListChange }
        />
      </fieldset>
    )
  }
}

export default DocumentoImpuestosRetencionesManager;